var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection-grid"},[_c('selection-company',{staticStyle:{"grid-area":"selection"}}),_c('div',{staticClass:"button-area"}),_c('management-employee-table',{key:_vm.$route.fullPath,staticStyle:{"grid-area":"table"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }